import React from 'react'
import EmblaCarousel from './embla/emblaCarousel'

const TestimonialGallery = ({ slice }) => {
  return (
    <section className='component-testimonial_gallery mx-auto max-w-screen-xl p-4'>
      <div className='relative mx-auto max-w-5xl px-10 md:py-8'>
        {slice.primary.quote_title.text && (
          <div className='prose-lg min-w-full pt-16 pb-10 text-center'>
            <h2 className='uppercase text-primary'>{slice.primary.quote_title.text}</h2>
          </div>
        )}
        <EmblaCarousel auto={true} arrows={true} delayLength={6000} dots={false} loop={true} slice={slice}>
          {slice.items.map((item, testimonialIndex) => {
            return (
              <div className='relative min-w-full py-6 text-center md:text-left' key={`item-${testimonialIndex}`}>
                <blockquote className='relative z-10'>
                  <p className='mb-5 text-xl'>{item.quote}</p>
                  <footer className='text-gray-500'>
                    {item.author}
                    {item.author && item.role && ' - '}
                    {item.role}
                    {(item.author || item.role) && ','} {item.company}
                  </footer>
                </blockquote>
              </div>
            )
          })}
        </EmblaCarousel>
      </div>
    </section>
  )
}

export default TestimonialGallery
